// AUTO-GENERATED from docs/TECHNICAL_PRD.md — CID Agent PWA API layer
// Module: Foundation — Agent Auth, /api/agent namespace, ownership middleware, push infra, data-model migrations
// Every list (collection GET) takes params { page, limit, ...filters }.
import client from './client';

/**
 * POST /api/agent/auth/login
 * Agent logs in with the email + temporary/changed password issued at onboarding; returns access + long-lived refresh tokens and a self profile.
 * @disposition BUILD_NEW · maps to POST /api/admin/auth/login (auth.service.login)
 */
export const createAuthLogin = (data = {}) => client.post(`/api/agent/auth/login`, data);

/**
 * POST /api/agent/auth/refresh
 * Exchange a valid refresh token for a new access + rotated refresh token (drives silent re-auth on app resume).
 * @disposition BUILD_NEW · maps to POST /api/admin/auth/refresh (auth.service.refreshToken)
 */
export const createAuthRefresh = (data = {}) => client.post(`/api/agent/auth/refresh`, data);

/**
 * POST /api/agent/auth/logout
 * Revoke the presented refresh token (single-device logout).
 * @disposition BUILD_NEW · maps to POST /api/admin/auth/logout (auth.service.logout)
 */
export const createAuthLogout = (data = {}) => client.post(`/api/agent/auth/logout`, data);

/**
 * POST /api/agent/auth/forgot-password
 * Agent requests a password-reset email; always returns success to avoid email enumeration.
 * @disposition BUILD_NEW · maps to POST /api/admin/auth/forgot-password (auth.service.forgotPassword)
 */
export const createAuthForgotPassword = (data = {}) => client.post(`/api/agent/auth/forgot-password`, data);

/**
 * POST /api/agent/auth/reset-password
 * Complete password reset with the emailed token.
 * @disposition BUILD_NEW · maps to POST /api/admin/auth/reset-password (auth.service.resetPassword)
 */
export const createAuthResetPassword = (data = {}) => client.post(`/api/agent/auth/reset-password`, data);

/**
 * GET /api/agent/me [LIST · paginated]
 * Return the caller agent's own profile for the PWA header/settings.
 * @disposition ADAPT_SCOPE · maps to GET /api/admin/auth/me (auth.service.getProfile)
 */
export const listMe = (params = {}) => client.get(`/api/agent/me`, { params });

/**
 * PUT /api/agent/me
 * Agent self-updates a whitelisted subset of profile fields.
 * @disposition ADAPT_SCOPE · maps to PUT /api/admin/auth/me (auth.service.updateProfile)
 */
export const updateMe = (data = {}) => client.put(`/api/agent/me`, data);

/**
 * PUT /api/agent/me/password
 * Agent changes password while logged in (verifies current password).
 * @disposition BUILD_NEW · maps to PUT /api/admin/auth/me/password (auth.service.changePassword)
 */
export const updateMePassword = (data = {}) => client.put(`/api/agent/me/password`, data);

/**
 * POST /api/agent/push/register
 * Register a Web Push (VAPID) subscription / FCM token for the caller's current device so the server can send push notifications.
 * @disposition BUILD_NEW
 */
export const createPushRegister = (data = {}) => client.post(`/api/agent/push/register`, data);

/**
 * POST /api/agent/push/unregister
 * Deregister the current device's push subscription (logout / notifications-off).
 * @disposition BUILD_NEW
 */
export const createPushUnregister = (data = {}) => client.post(`/api/agent/push/unregister`, data);
